import ModalForm from "./Form";
import {
	BANK_ACCOUNT,
	DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "BANK-ACCOUNT-table",
			rowData: {},
			formId: "BANK-ACCOUNT-form",
			tableColumns: [
				{
					title: "Center",
					type: "custom-html",
					key: "center",
					isVisible: true,
					modifier: (value) => {
						return value ? value.name : ''
					},
					sortable: true,
				},
				{
					title: "Bank Name",
					type: "custom-html",
					key: "bank_id",
					isVisible: true,
					modifier: (value) => {
						return value ? value.bank_name : ''
					},
					sortable: true,
				},
				{
					title: "Bank Account Name",
					type: "text",
					key: "bank_account_name",
					sortable: true,
				},
				{
					title: "Bank Account No",
					type: "text",
					key: "bank_account_no",
					sortable: true,
				},
				{
					title: "Finance Book No",
					type: "text",
					key: "bank_account_virtual_no",
					sortable: true,
				},
				{
					title: this.$t("is_active"),
					type: "custom-html",
					key: "is_active",
					isVisible: true,
					modifier: (value) => {
						let ClassName = "danger";

						if (value === 1) ClassName = `success`;
						else if (value === 0) ClassName = `warning`;

						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
							value ? "Active" : "Inactive"
						}</span>`;
					},
				},
			],
			ENDPOINT: BANK_ACCOUNT,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Bank",
				url: BANK_ACCOUNT,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "BANK-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
					{
						title: this.$t("is_active"),
						type: "checkbox",
						key: "is_active",
						option: [
							{ id: true, value: "Active" },
							{ id: false, value: "Inactive" },
						],
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = BANK_ACCOUNT + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
